import { render } from "./detailDescription.vue?vue&type=template&id=f509bf98&scoped=true"
import script from "./detailDescription.vue?vue&type=script&lang=js"
export * from "./detailDescription.vue?vue&type=script&lang=js"

import "./detailDescription.vue?vue&type=style&index=0&id=f509bf98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f509bf98"]])

export default __exports__